module.exports = __webpack_public_path__ + "img/product9.a0d92199.jpg";